import { PhotoFrame } from "@/components/Photo";
import { usePhotos } from "@/hooks/usePhotos";
import { useFaculty } from "@/hooks/useFaculty";
import { Reveal } from "@/components/Reveal";
import { TONES } from "@/lib/tones";

const ORDER = ["gold", "teal", "violet", "berry"];
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const FacultyRow = ({ f, i }) => {
  const { first } = usePhotos("faculty", f.id);
  const t = TONES[ORDER[i % 4]];
  const lines = (f.qualification || "").split("\n").map((l) => l.trim()).filter(Boolean);
  return (
    <div data-testid={`faculty-${slug(f.name)}`} className="tilt-card glass relative flex items-center gap-5 overflow-hidden rounded-3xl p-5" style={{ borderTop: `4px solid ${t.hex}` }}>
      <PhotoFrame photo={first} ratio="aspect-square" rounded="rounded-2xl" initials={f.name} alt={f.name} className="w-24 shrink-0 sm:w-28" testid={`faculty-photo-${slug(f.name)}`} />
      <div className="min-w-0">
        <p className="font-display text-xl font-semibold leading-tight text-forest">{f.name}</p>
        {f.subject && <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: t.hex }}>Subject: {f.subject}</p>}
        {lines.length > 0 && <ul className="mt-2 space-y-0.5 text-sm leading-relaxed text-charcoal/80">{lines.map((l) => <li key={l}>{l}</li>)}</ul>}
      </div>
    </div>
  );
};

export const FacultyList = () => {
  const faculty = useFaculty();
  return (
    <div data-testid="faculty-list" className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {faculty.map((f, i) => (
        <Reveal key={f.id} delay={(i % 3) * 0.07}><FacultyRow f={f} i={i} /></Reveal>
      ))}
    </div>
  );
};
